export function productFinishModal() {
  return {
    isFinishModalOpen: false,
    selectedFinish: null,
    
    openFinishModal(finish) {
      // Close any other open modals first
      this.closeAllModals();
      
      // Set the selected finish data
      this.selectedFinish = {
        id: finish.id,
        title: finish.title,
        image: finish.image,
        category: finish.category,
        finishCode: finish.finishCode,
        programClassification: finish.programClassification,
        characteristics: finish.characteristics || [],
        productApplications: finish.productApplications,
        specs: finish.specs
      };
      
      this.isFinishModalOpen = true;
      document.body.style.overflow = 'hidden';
    },
    
    closeFinishModal() {
      this.isFinishModalOpen = false;
      this.selectedFinish = null;
      document.body.style.overflow = '';
    },
    
    closeAllModals() {
      // Close team bio modal if it exists and is open
      if (this.isOpen !== undefined) {
        this.isOpen = false;
      }
      
      // Close any other modals that might be open
      // Add more modal closures here as needed
      
      // Reset body overflow
      document.body.style.overflow = '';
    },
    
    // Handle escape key and backdrop click
    handleKeydown(event) {
      if (event.key === 'Escape' && this.isFinishModalOpen) {
        this.closeFinishModal();
      }
    }
  };
}